export default __webpack_public_path__ + "img/shared.f7d1f864.svg";